import { EventAggregator } from 'aurelia-event-aggregator';
import { bindable, autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { State } from '../../services/global-state';
import { AutopayService } from './autopay.service';
import { Account } from '../../models/customer';
import { Portfolio } from '../../models/portfolio';
import { Autopay } from '../../models/autopay';
import { PortalTemplateTypes } from '../../services/template-service';

@autoinject
export class EditAutopayReceipt {
	isLoading = true;
	paymentInformation: any;
	account: Account;
	portfolio: Portfolio;
	autopay: Autopay;
	bucketKey: number | null;

	constructor(
		private globalState: State,
		private router: Router,
		private eventAggregator: EventAggregator,
		private autopayService: AutopayService
	) {
	}
	activate(model) {
		this.account = this.globalState.accounts.find((element, index, array) => {
			return element.id === model.id;
		});
		this.portfolio = this.globalState.customer.portfolios.find((element, index, array) => {
			return element.portfolioName === this.account.portfolioName;
		});
		this.bucketKey = this.account.bucket
			? this.account.bucket.bucketKey
			: this.account.bucketKey || null;

		if (!this.autopayService.autopay) {
			this.goToView();
		}

		this.getPaymentInformation();
	}

	getPaymentInformation() {
		this.paymentInformation = {
			portalTemplateType: PortalTemplateTypes.AutopayPlanReceipt,
			autopayKey: this.autopayService.autopay.key,
			merchantKey: '',
			savedPaymentMethodToWallet: this.autopayService.savedToWallet
		};

		if (this.globalState.business.portalSettings.businessSettings.enableCustomerAccountName) {
			this.paymentInformation.customerAccountName = this.account.name;
		}

		this.isLoading = false;
	}

	showError(error: string) {
		// TODO: Use something other than alerts here, like toast
		alert(error);
	}

	goToView() {
		this.router.navigateToRoute('autopay/view-autopay', { id: this.account.id });
	}
}
